import { useQuery } from '@tanstack/react-query'
import { queryKeys, QUERY_CONFIG } from '../../lib/react-query'
import { dashboardApi } from '../../services/api/dashboard.api' // DIRECT — never the barrel
import { useFeature } from '../../Utils/featureFlagEngine'
import type { MultiOrgDashboardResponse } from '../../app/modules/types/multi-org-dashboard'

/**
 * Hook for fetching the group board's multi-organization dashboard data,
 * with auto-refresh every 10 minutes.
 *
 * Gated on the `org_dashboard` feature: `FeatureGuard` only hides the UI, so
 * the request itself has to be stopped here or a disabled board would still
 * poll the endpoint every 10 minutes.
 *
 * @param autoRefresh - Enable auto-refresh (default: true)
 */
export function useMultiOrgDashboard(autoRefresh = true) {
  const { isEnabled } = useFeature()
  const enabled = isEnabled('org_dashboard')

  return useQuery<MultiOrgDashboardResponse>({
    queryKey: queryKeys.multiOrgDashboard.data,
    queryFn: () => dashboardApi.getMultiOrgData(),
    enabled,
    staleTime: QUERY_CONFIG.LISTS.staleTime,
    refetchInterval: autoRefresh && enabled ? 10 * 60 * 1000 : false,
  })
}
